import './FilterableList.scss'

import { memo } from 'react'

import { EmptyComponent } from './Components/EmptyComponent'
import { ErrorComponent } from './Components/ErrorComponent'
import { TimeoutError } from './Components/TimeoutError'
import { FilterableListContext } from './FilterableListContext'
import { FilterableListSwitcher } from './FilterableListSwitcher'
import { FilterableListProps, TranslationsType } from './FilterableListTypes'
import { ERROR_CODE_BACKEND_TIMEOUT } from '@react/ListWrapper/hooks/timeoutHandler'

export const FilterableList = memo(function FilterableList({
  listStyleTemplate,
  isLoading,
  onLoadMore,
  responseData,
  translations,
  ...rest
}: FilterableListProps) {
  let translationsState: TranslationsType
  try {
    translationsState = JSON.parse(translations)
  } catch (e) {
    translationsState = null
  }

  if (typeof responseData === 'string' && responseData === 'error') {
    return <ErrorComponent message={translationsState.error} />
  }

  if (responseData?.errorCode === ERROR_CODE_BACKEND_TIMEOUT && !responseData?.loadMoreError) {
    return <TimeoutError title={translationsState.pageLoadTimeoutErrorTitle} description={translationsState.pageLoadTimeoutErrorDescription} />
  }

  if (responseData.items.length < 1 && !responseData?.errorCode && 'type' in rest && rest.type !== 'relatedJob') {
    return <EmptyComponent message={translationsState.noResultsFound ?? translationsState.noResults} description={translationsState.noResultsDescription} />
  }

  return (
    <FilterableListContext.Provider value={{ isLoading, onLoadMore, responseData, propsState: { ...rest, listStyleTemplate }, translationsState }}>
      <FilterableListSwitcher />      {responseData?.errorCode === ERROR_CODE_BACKEND_TIMEOUT && responseData?.loadMoreError && (
        <TimeoutError title={translationsState.loadMoreTimeoutErrorTitle} isLoadMoreError={true} />
      )}    </FilterableListContext.Provider>
  )
})
